import { defineStore } from 'pinia'
import { markRaw } from 'vue'

import CouponExpiredDialogContent from '@/nordy/components/CouponExpiredDialogContent.vue'
import InstallRequestSubscriptionModal from '@/nordy/components/InstallRequestSubscriptionModal.vue'
import LoginDialogContent from '@/nordy/components/LoginDialogContent.vue'
import PurchaseDialogContent from '@/nordy/components/PurchaseDialogContent.vue'
import { useDialogStore } from '@/stores/dialogStore'

//!nordy - dialogStore 기반 글로벌 모달 관리 (PrimeVue Dialog 직접 사용 제거)
export const useNordyModalStore = defineStore('nordyModal', () => {
  const installRequestSubscriptionDialogKey =
    'nordy-install-request-subscription'

  function openLoginModal() {
    const dialogStore = useDialogStore()
    if (dialogStore.isDialogOpen('nordy-login')) return
    dialogStore.showDialog({
      key: 'nordy-login',
      title: 'Login',
      component: markRaw(LoginDialogContent),
      props: {},
      dialogComponentProps: {
        modal: true,
        closable: true,
        dismissableMask: true
      }
    })
  }

  function closeLoginModal() {
    useDialogStore().closeDialog({ key: 'nordy-login' })
  }

  function openPurchaseModal() {
    const dialogStore = useDialogStore()
    if (dialogStore.isDialogOpen('nordy-purchase')) return
    dialogStore.showDialog({
      key: 'nordy-purchase',
      title: 'Credits',
      component: markRaw(PurchaseDialogContent),
      props: {},
      dialogComponentProps: {
        modal: true,
        closable: true,
        dismissableMask: true,
        closeButtonProps: { id: 'close_creditalert' }
      }
    })
  }

  function closePurchaseModal() {
    useDialogStore().closeDialog({ key: 'nordy-purchase' })
  }

  function openCouponExpiredModal() {
    const dialogStore = useDialogStore()
    if (dialogStore.isDialogOpen('nordy-coupon-expired')) return
    dialogStore.showDialog({
      key: 'nordy-coupon-expired',
      title: '',
      component: markRaw(CouponExpiredDialogContent),
      props: {},
      dialogComponentProps: {
        modal: true,
        closable: true,
        dismissableMask: true
      }
    })
  }

  function closeCouponExpiredModal() {
    useDialogStore().closeDialog({ key: 'nordy-coupon-expired' })
  }

  function openInstallRequestSubscriptionModal() {
    const dialogStore = useDialogStore()
    if (dialogStore.isDialogOpen(installRequestSubscriptionDialogKey)) return

    dialogStore.showDialog({
      key: installRequestSubscriptionDialogKey,
      title: '',
      component: markRaw(InstallRequestSubscriptionModal),
      props: {},
      dialogComponentProps: {
        modal: true,
        closable: true,
        dismissableMask: true,
        headless: true,
        style: 'width: min(512px, 95vw);',
        pt: {
          root: { class: 'rounded-2xl border-none bg-transparent' },
          content: { class: '!p-0' }
        }
      }
    })
  }

  return {
    openLoginModal,
    closeLoginModal,
    openPurchaseModal,
    closePurchaseModal,
    openCouponExpiredModal,
    closeCouponExpiredModal,
    openInstallRequestSubscriptionModal
  }
})
